import { AlertTriangle, Inbox, type LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { apiErrorMessage } from '@/i18n'

export function EmptyState({ title, description, icon: Icon = Inbox, action }: { title?: string; description?: ReactNode; icon?: LucideIcon; action?: ReactNode }) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-6 py-12 text-center">
      <div className="rounded-full bg-muted p-3 text-muted-foreground">
        <Icon className="size-5" aria-hidden />
      </div>
      <p className="text-sm font-medium">{title ?? t('common.empty')}</p>
      {description ? <p className="max-w-sm text-xs text-muted-foreground">{description}</p> : null}
      {action}
    </div>
  )
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const { t } = useTranslation()
  const msg = apiErrorMessage(error)
  return (
    <div role="alert" className="flex flex-col items-center gap-3 px-6 py-10 text-center">
      <div className="rounded-full bg-destructive/12 p-3 text-destructive">
        <AlertTriangle className="size-5" aria-hidden />
      </div>
      <p className="max-w-md text-sm">{msg}</p>
      {onRetry ? (
        <Button variant="outline" size="sm" onClick={onRetry}>
          {t('common.retry')}
        </Button>
      ) : null}
    </div>
  )
}
